import VDMDashboardPortCalls from "components/app/vdmdashboard/port-calls/VDMDashboardPortCalls";
import React from "react";

type ScreenVDMDashboardPortCallsType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardPortCalls: React.FC<ScreenVDMDashboardPortCallsType> = (
	props: ScreenVDMDashboardPortCallsType
) => {
	return <VDMDashboardPortCalls vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardPortCalls;